import React, { Component } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Progress } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import CustomRoutes from '../Routes';
import 'react-toastify/dist/ReactToastify.css';

export default class bodyContainer extends Component {
	constructor() {
		super();

		this.callsInProgress = 0;

		this.state = {
			inProgress: false,
			uploading: false,
			loaded: 0
		};

		this.inProgress = this.inProgress.bind(this);
	}

	componentDidMount() {
	}

	inProgress(value, uploading, loaded) {
		if (uploading) {
			this.setState({ uploading: uploading, loaded: loaded });
		}
		else {
			if (value === true) {
				// Treat repeated starts for the same global loading state as
				// idempotent. A boolean API cannot identify concurrent callers,
				// and incrementing the counter for every rerender can leave the
				// Backdrop permanently open and block the application.
				if (!this.state.inProgress) {
					this.callsInProgress = 1;
					this.setState({ inProgress: true, uploading: uploading, loaded: loaded });
				}
			}
			else if (value === false) {
				this.callsInProgress = 0;
				this.setState({ inProgress: false, uploading: uploading, loaded: loaded });
			}
		}

		return value === undefined ? this.state.inProgress : value;
	}

	render() {
		// variant="new": rendered inside the redesign shell (src/redesign/shell/NewShell.js), which owns the page offset and padding.
		const isNew = this.props.variant === 'new';
		return (
			<div className={isNew ? 'apw2-page' : 'content_down'}>
				<div id="dLicErrMsg" style={{ display: "block" }}>
					<div id="dLicErrMsg1" style={isNew ? { padding: "8px 24px 0", fontWeight: 600, fontSize: "13px", color: "rgb(206, 67, 2)" } : { padding: "10px 0 0", marginLeft: "19px", fontWeight: "bold", width: "99%", height: "5px", float: "left", fontFamily: "Open Sans, sans-serif", fontSize: "14px", color: "rgb(206, 67, 2)" }}>
					</div>
				</div>
				<main role="main" className={isNew ? 'apw2-main' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12'}>
					<CustomRoutes inProgress={this.inProgress} />
				</main>
				<Backdrop style={{ zIndex: 5000, color: '#fff' }} open={this.state.inProgress}>
					<Progress max="100" color="success" style={{ width: "1024px", display: this.state.uploading ? "" : "none" }} value={this.state.loaded} >{Math.round(this.state.loaded, 2)}%</Progress>
					<CircularProgress color="inherit" style={{ display: this.state.inProgress && !this.state.uploading ? "" : "none" }} />
				</Backdrop>
				<ToastContainer
					position="top-right"
					newestOnTop
					closeOnClick
				/>
			</div>
		);
	}
}